import { useState } from "react"
import "./Login.css"
import language from "../../data/language";
import axios from "axios";
import {useSelector, useDispatch} from "react-redux";
import { usersActions } from "../../data/user";
import notify from "../../common/ui/notify";
import { langUrl } from "../../common/langRouting";



const Login = () => {
    const [formData, setFormData] = useState({user: "", password: ""});
    const lang = localStorage.language ? localStorage.language : "geo";
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handlers = {
        async login(e){
            e.preventDefault();
            if (loading) return;
            setLoading(true);
            try {
                const res = await axios.post('/api/login', formData);
                const data = res.data.data;
                dispatch(usersActions.changeIsLoggedIn(true));
                dispatch(usersActions.saveUserData(data));
                // Admins land straight in the panel, everyone else on the home page.
                window.location.href = langUrl(data && data.role === "admin" ? "/admin/cars" : "/");
            } catch (err) {
                // Deliberately vague: never reveal whether the username exists.
                notify.error({
                    en: "Incorrect username or password.",
                    geo: "მომხმარებელი ან პაროლი არასწორია.",
                    ru: "Неверный логин или пароль.",
                    am: "Սխալ օգտանուն կամ գաղտնաբառ։"
                });
                setLoading(false);
            }
        }
    }

    return(
        <div className="login-page-container container">
            <div className="row" style={{width: "100%"}}>
                <div className="col-md-6" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <form className="login-form-container" onSubmit={handlers.login} style={{maxWidth: "400px", width: "100%"}}>
                        <div className="form-group">
                            <label style={{color: "white", marginBottom: '7px'}}>{language[lang].login.user}:</label>
                            <input required className="form-control" name="username" style={{height: "52px"}} value={formData.user} onChange={(e) => setFormData((prev) => ({...prev, user: e.target.value}))} placeholder=""/>
                        </div>
                        <div className="form-group">
                            <label style={{color: "white", marginBottom: '7px', marginTop: "30px"}}>{language[lang].login.password}:</label>
                            <input required type="password" className="form-control" name="password" autoComplete="current-password" style={{height: "52px"}} value={formData.password} onChange={(e) => setFormData((prev) => ({...prev, password: e.target.value}))} placeholder=""/>
                        </div>
                        <div className="login-action-buttons">
                            <button className="login-button" type="submit" disabled={loading}>
                                {loading
                                    ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    : language[lang].header.login}
                            </button>
                        </div>
                    </form>
                </div>
                <div className="col-md-6">
                    <div className="login-page-banner" style={{backgroundImage: 'url("/static/main-page-banner.jpg")'}}>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login